/**
 * Custom hook for managing lead status configurations
 * Provides centralized status color mappings, label mappings, and helper functions
 */

const useLeadStatus = () => {
    // Status to color mapping for badge styling
    const STATUS_COLOR_MAP = {
        new: "primary",
        qualified: "info",
        processing: "warning",
        readyToGo: "success",
        carBooked: "success",
        paperWork: "warning",
        parkedForSale: "info",
        loan: "info",
        delivered: "success",
        lost: "danger",
        notQualified: "secondary",
        notConnected: "dark",
    }

    // Status to label mapping for display
    const STATUS_LABEL_MAP = {
        new: "New",
        qualified: "Qualified",
        processing: "Processing",
        readyToGo: "Ready To Go",
        carBooked: "Car Booked",
        paperWork: "Paper Work",
        parkedForSale: "Parked For Sale",
        loan: "Loan",
        delivered: "Delivered",
        lost: "Lost",
        notQualified: "Not Qualified",
        notConnected: "Not Connected",
    }

    // Status label mapping for purchase leads
    const PURCHASE_STATUS_LABEL_MAP = {
        ...STATUS_LABEL_MAP,
        readyToGo: "Ready",
        carBooked: "Car Checked",
        delivered: "Purchased",
    }

    /**
     * Get the color class for a given status
     * @param {string} status - The status key
     * @returns {string} - The color class (e.g., "primary", "success")
     */
    const getStatusColor = (status) => {
        return STATUS_COLOR_MAP[status] || "primary"
    }

    /**
     * Get the display label for a given status
     * @param {string} status - The status key
     * @param {string} leadType - The lead type (e.g. 'purchase', 'sales')
     * @returns {string} - The display label (e.g., "New", "Ready To Go")
     */
    const getStatusLabel = (status, leadType) => {
        if (leadType === "purchase") {
            return PURCHASE_STATUS_LABEL_MAP[status] || STATUS_LABEL_MAP[status] || "New"
        }
        return STATUS_LABEL_MAP[status] || "New"
    }

    return {
        STATUS_COLOR_MAP,
        STATUS_LABEL_MAP,
        getStatusColor,
        getStatusLabel,
    }
}

export default useLeadStatus
